import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/auth'
import 'firebase/compat/database'
import 'firebase/compat/storage'
import 'firebase/storage'

// original
// const firebaseConfig = {
//   apiKey: "AIzaSyAXEBF-HxBk3c534hcImDoU-uKuq2v2Nt8",
//   authDomain: "olx-clone-react-8d128.firebaseapp.com",
//   projectId: "olx-clone-react-8d128",
//   storageBucket: "olx-clone-react-8d128.appspot.com",
//   messagingSenderId: "1026285536776",
//   appId: "1:1026285536776:web:4c1d6c700dad5a6456b3bd"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyCas8PeTIMdVyzque1PWmHGnDz0pLheGSg",
//   authDomain: "marketsquare-39bff.firebaseapp.com",
//   projectId: "marketsquare-39bff",
//   storageBucket: "marketsquare-39bff.appspot.com",
//   messagingSenderId: "903060911849",
//   appId: "1:903060911849:web:53d8702ade499569d06278"
// };

// aswinkrishna363
// const firebaseConfig = {
//   apiKey: "AIzaSyAoZLQcixtNiTGAVjYC5HhpG-REHPdrLFs",
//   authDomain: "marketsquare-7450b.firebaseapp.com",
//   projectId: "marketsquare-7450b",
//   storageBucket: "marketsquare-7450b.appspot.com",
//   messagingSenderId: "963851883264",
//   appId: "1:963851883264:web:e5e4c7ef073d4ecbdbd9e5"
// };
const firebaseConfig = {
  apiKey: "AIzaSyA8sYLroopLzS_7Ks3VtJm6iW1rrmUBFhg",
  authDomain: "ecom-8970f.firebaseapp.com",
  projectId: "ecom-8970f",
  storageBucket: "ecom-8970f.appspot.com",
  messagingSenderId: "31986988449",
  appId: "1:31986988449:web:0f63c702e6c1f2f7f487e0"
};
export default firebase.initializeApp(firebaseConfig)